import { apiFetch } from './apiFetch';

const API_BASE = process.env.REACT_APP_API_URL;

export async function fetchUserData(userId) {
  const res = await apiFetch(`${API_BASE}/admin/data/${userId}`);
  return res.json();
}
